<ng-container *ngIf="!loading">

  <!-- City map background.
       Mode payant : scrolle avec le contenu (position: absolute).
       Mode free   : reste visible via background-attachment: fixed. -->
  <div *ngIf="(!user.reseller || user.reseller.displayCourse) && langTgtSrv.current.displayCourse"
       class="gs__map-bg"
       [style.backgroundImage]="'url(assets/images/maps/' + langTgtSrv.current.code + '.png)'"
       aria-hidden="true">
  </div>

  <!-- Parcours SVG -->
  <app-course-map
    *ngIf="(!user.reseller || user.reseller.displayCourse) && langTgtSrv.current.displayCourse && (data.sections || data.levels)"
    [sections]="data.sections || data.levels"
    [current]="data.currentSection ?? data.currentLevel"
    [trophies]="data.trophies"
    [mode]="courseMapMode">
  </app-course-map>

  <!-- Fallback liste (reseller sans parcours visuel) -->
  <div *ngIf="(user.reseller && !user.reseller.displayCourse) || !langTgtSrv.current.displayCourse" class="container py-5">

    <div class="row mt-2" *ngIf="data.sections">
      <div class="col-12 col-md-6 mb-3"
           *ngFor="let section of data.sections; trackBy: trackById"
           [class.pointer]="section.unlocked"
           [class.section-disabled]="!section.unlocked"
           (click)="navigateToSection(section)"
           id="{{section.id}}">
        <div class="h-100 media p-3 light-rounded shadow-card bg-white-gradient" *ngIf="!section.isExam">
          <div class="align-self-center mr-3">
            <img src="assets/images/monuments/{{langTgtSrv.current.code}}.png" class="thumbnail" alt=""/>
          </div>
          <div class="media-body align-self-center">
            <div class="mb-3 nunito text-darklight">{{ section.name }}</div>
            <app-progress-bar-light [score]="section.score"></app-progress-bar-light>
          </div>
        </div>

        <!-- Examen de fin de palier CEFRL -->
        <div class="h-100 media p-3 light-rounded shadow-card bg-white-gradient exam-tile" *ngIf="section.isExam">
          <div class="align-self-center mr-3 exam-tile-icon">
            <i class="fa-solid" [class.fa-graduation-cap]="section.unlocked" [class.fa-lock]="!section.unlocked"></i>
          </div>
          <div class="media-body align-self-center">
            <div class="nunito text-darklight">
              {{ section.name }}
              <span class="exam-tile-cefrl" *ngIf="section.cefrl">{{ section.cefrl }}</span>
            </div>
            <div class="mt-2">
              <span class="exam-badge exam-badge-todo" *ngIf="section.unlocked && section.exam?.status === 'todo'" translate>À passer</span>
              <span class="exam-badge exam-badge-passed" *ngIf="section.exam?.status === 'passed'">
                <i class="fa-solid fa-circle-check mr-1"></i><span translate>Réussi</span> — {{ section.exam.bestScore }}%
              </span>
              <span class="exam-badge exam-badge-failed" *ngIf="section.exam?.status === 'failed'">
                <i class="fa-solid fa-circle-xmark mr-1"></i><span translate>Raté</span> — {{ section.exam.bestScore }}%
              </span>
              <span class="exam-badge exam-badge-locked" *ngIf="!section.unlocked" translate>Verrouillé</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2" *ngIf="data.levels">
      <div class="col-12 col-md-6 mb-3"
           *ngFor="let level of data.levels; trackBy: trackById"
           [class.pointer]="level.unlocked"
           [class.section-disabled]="!level.unlocked"
           (click)="navigateToSection(level)"
           id="{{level.id}}">
        <div class="h-100 media p-3 light-rounded shadow-card bg-white-gradient">
          <div class="align-self-center mr-3">
            <img src="assets/images/monuments/{{langTgtSrv.current.code}}.png" class="thumbnail" alt=""/>
          </div>
          <div class="media-body align-self-center">
            <div class="mb-3 nunito text-darklight">{{ level.name }}</div>
            <app-progress-bar-light [score]="level.score"></app-progress-bar-light>
          </div>
        </div>
      </div>
    </div>

  </div>

</ng-container>
